import script from "./ResourceBoardDetailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceBoardDetailView.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceBoardDetailView.vue?vue&type=style&index=0&id=39ef9e20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ef9e20"]])

export default __exports__